export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Login.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'SignOut',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/dashboard',
    meta: {
      breadcrumb: true
    },
    name: 'Dashboard',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Dashboard.vue`
    )
  },

  {
    path: '/calendarview',
    meta: {
      breadcrumb: true
    },
    name: 'calendarview',
    component: (a) => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/Calendarpage.vue`
    )
  },
  {
    path: '/task',
    meta: {
      breadcrumb: true
    },
    name: 'Task',
    component: (a) => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      // `@/components/task/TaskLayout.vue`
      `@/pages/task/taskview.vue`
      // `@/pages/task/sataskListview.vue`
    )
  },
  {
    path: '/coversation',
    meta: {
      breadcrumb: false
    },
    name: 'Coversation',
    component: (a) => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      // `@/components/task/TaskLayout.vue`
      `@/pages/task/aKtaskConversation.vue`
      // `@/pages/task/sataskListview.vue`
    )
  },
  {
    path: '/task/:id',
    meta: {
      breadcrumb: true
    },
    name: 'TaskDash',
    component: (a) => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      // `@/components/task/TaskLayout.vue`
      `@/pages/task/taskview.vue`
      // `@/pages/task/sataskListview.vue`
    )
  },
  {
    path: '/tasktreeview/:id',
    meta: {
      breadcrumb: false
    },
    name: 'taskTreeView',
    component: (a) => import(

      `@/pages/task/taskformdetails.vue`

    )
  },
  {
    path: '/media',
    meta: {
      breadcrumb: true
    },
    name: 'Media',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Media.vue`
    )
  },
  {
    path: 'generalitemssettings/newdocument',
    meta: {
      breadcrumb: true
    },
    name: 'generalitemsapp/NewDocument',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/NewDocument.vue`
    )
  },
  {
    path: 'generalitemssettings/newfolder',
    meta: {
      breadcrumb: true
    },
    name: 'generalitemsapp/NewFolder',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/NewFolder.vue`
    )
  },
  {
    path: 'generalitemssettings/shortcut',
    meta: {
      breadcrumb: true
    },
    name: 'generalitemsapp/ShortCut',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/ShortCut.vue`
    )
  },
  {
    path: 'generalitemssettings/newcompounddoc',
    meta: {
      breadcrumb: true
    },
    name: 'generalitemsapp/NewCompoundDoc',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/NewCompoundDoc.vue`
    )
  },
  {
    path: 'dmssettings/personalfolder',
    meta: {
      breadcrumb: true
    },
    name: 'dmsapp/PersonalFolder',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/PersonalFolder.vue`
    )
  },

  {
    path: 'dmssettings/publicfolder',
    meta: {
      breadcrumb: true
    },
    name: 'dmsapp/PublicFolder',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/PublicFolder.vue`
    )
  },
  {
    path: 'dmssettings/administration',
    meta: {
      breadcrumb: true
    },
    name: 'dmsapp/Administration',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/Administration.vue`
    )
  },
  {
    path: 'dmssettings/documentprofile',
    meta: {
      breadcrumb: true
    },
    name: 'dmsapp/DocumentProfile',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/DocumentProfile.vue`
    )
  },
  {
    path: 'dmssettings/accessrights',
    meta: {
      breadcrumb: true
    },
    name: 'dmsapp/AccessRights',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/document/AccessRights.vue`
    )
  },
  // {
  //   path: 'dmssettings/audittrail',
  //   meta: {
  //     breadcrumb: true
  //   },
  //   name: 'dmsapp/AuditTrail',
  //   props: (route) => ({
  //     type: route.query.type
  //   }),
  //   component: () => import(
  //     /* webpackChunkName: "routes" */
  //     /* webpackMode: "lazy-once" */
  //     `@/pages/document/AuditTrail.vue`
  //   )
  // },
  {
    path: 'tasksettings/project',
    meta: {
      breadcrumb: true
    },
    name: 'taskapp/Projects',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Projects.vue`
    )
  },
  {
    path: 'tasksettings/team',
    meta: {
      breadcrumb: true
    },
    name: 'taskapp/Team',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Team.vue`
    )
  },
  {
    path: 'tasksettings/tags',
    meta: {
      breadcrumb: true
    },
    name: 'taskapp/Tag',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Tag.vue`
    )
  },
  {
    path: '/scrapsettings/plasticbag',
    meta: {
      breadcrumb: true
    },
    name: 'app/plasticbag',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/PlasticBag.vue`
    )
  }, {
    path: '/scrapsettings/blisterType',
    meta: {
      breadcrumb: true
    },
    name: 'app/blisterType',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/BlisterScrapCode.vue`
    )
  },
  {
    path: '/contacts',
    meta: {
      breadcrumb: true
    },
    name: 'Contact',
    props: (route) => ({
      type: route.query.type
    }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/contact/ContactList.vue`
    )
  },

  {
    path: '/calendarsettings/companyevent',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/companyevent',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/MasterEventList.vue`
    )
  },
  {
    path: '/calendarsettings/prodplanning',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/prodplanning',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/ProductionPlan.vue`
    )
  },
  {
    path: '/calendarsettings/yearlyevent',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/yearlyevent',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/YearlyEvent.vue`
    )
  },
  {
    path: '/calendarsettings/workdate',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/workdate',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/WorkDate.vue`
    )
  },
  {
    path: '/calendarsettings/workday',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/workday',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/WorkDay.vue`
    )
  },
  {
    path: '/calendarsettings/holiday',
    meta: {
      breadcrumb: true
    },
    name: 'calendar/holiday',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/calendar/HolidayList.vue`
    )
  },


  {
    path: '/scrap/srapmaster',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/srapmaster',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/ScrapMaster.vue`
    )
  },
  {
    path: '/scrap/blisterstrip',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/blisterstrip',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/BlisterStripWeight.vue`
    )
  },
  {
    path: '/scrap/postscrap',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/postscrap',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/BlisterScrapEntry.vue`
    )
  },
  {
    path: '/scrap/scrapentry',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/scrapentry',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/BlisterScrapEntryList.vue`
    )
  },
  {
    path: '/scrap/scrapmaster',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/allowablescrap',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/BlisterScrapList.vue`
    )
  },
  {
    path: '/scrap/prodscrapjournal',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/prodscrapjournal',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/ProductionScrapJournal.vue`
    )
  },
  {
    path: '/scrap/productionBOM',
    meta: {
      breadcrumb: true
    },
    name: 'scrap/productionBOM',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/scrap/ProductionBOM.vue`
    )
  },

  {
    path: '/appsettings/country',
    meta: {
      breadcrumb: true
    },
    name: 'app/country',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Country.vue`
    )
  },
  {
    path: '/appsettings/state',
    meta: {
      breadcrumb: true
    },
    name: 'app/state',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/State.vue`
    )
  },
  {
    path: '/appsettings/holiday',
    meta: {
      breadcrumb: true
    },
    name: 'app/holiday',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Holiday.vue`
    )
  },
  {
    path: '/appsettings/shift',
    meta: {
      breadcrumb: true
    },
    name: 'app/shift',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/masters/Shift.vue`
    )
  },

];


// WEBPACK FOOTER //
// ./src/router/paths.js